import { Modal } from '@memorizecards/ui';
import type { ReactNode } from 'react';
import { CardHtml } from './CardHtml';
import { Carregando, Erro } from './estado';
import { useCard } from '../lib/queries';

export function VisualizarCardModal({
  cardId,
  open,
  onClose,
}: {
  cardId: number | null;
  open: boolean;
  onClose: () => void;
}): ReactNode {
  const { data: card, isPending, error, refetch } = useCard(open ? cardId : null);

  return (
    <Modal open={open} onClose={onClose} title="Card completo" size="lg">
      {isPending ? <Carregando className="py-12" /> : null}
      {error ? <Erro error={error} aoTentarNovamente={() => void refetch()} /> : null}
      {card ? (
        <div className="flex flex-col gap-4">
          {card.caminho.length > 0 ? (
            <p className="mc-mono normal-case tracking-normal text-mc-ink3">
              {card.caminho.slice(2).join(' › ') || card.caminho.join(' › ')}
            </p>
          ) : null}
          <CardHtml html={card.pergunta || card.frente} className="text-lg" />
          <hr className="mc-rule" />
          <CardHtml html={card.verso} />
        </div>
      ) : null}
    </Modal>
  );
}
